<template lang="pug">
  //- simply to init cart before any other component
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'CartInit',
    computed: {
      ...mapState({
        sidecartOpen: (state) => state.cart.sidecartOpen,
        cartData: (state) => state.cart.checkout,
        items: (state) => state.cart.checkout.items,
        cartTotal: (state) => state.cart.checkout.total_price,
      }),
    },
    create() {
      this.$store.dispatch('cart/init');
    },
    mounted() {
      this.$store.dispatch('cart/init');
    },
  };
</script>
